// React Imports
import { useCallback } from 'react'

// Third-party Imports
import type { ParseFunction, RouterProvider } from '@refinedev/core'

// Util Imports
import { safeReturnTo } from './safe-next'

/**
 * Router-ийн `parse()`-ыг ороож `params.to`-г `safeReturnTo`-оор шүүнэ.
 *
 * ! 🔴 FE-02: `useLogin` (мөн `<Authenticated>`) нь `parse().params.to`-г
 * ! шалгалтгүй `go({ to, type: 'replace' })` хийдэг. `@refinedev/nextjs-router`
 * ! түүнийг qs-ээр задлаад `decodeURIComponent` хийдэг тул `?to[]=`, `?to[0]=`,
 * ! `?[to]=` бүгд мөр болж ирнэ. Хаягийн түлхүүрийг нэг бүрчлэн хаахын оронд
 * ! Refine-ийн БҮХ hook уншдаг энэ ГАНЦ цэгт шүүнэ — ямар ч кодчилол энд
 * ! эцсийн мөр болсон байдаг.
 *
 * ! Хуудсууд огнооны `?to=`-г `nuqs`/`useSearchParams`-аар уншдаг тул энэ
 * ! шүүлтүүр тэдэнд НӨЛӨӨЛӨХГҮЙ — зөвхөн Refine-ийн `parse()`. Түүнийг
 * ! уншдаг бусад нь `useMeta` (`meta.to`-г data-provider уншдаггүй) ба
 * ! `useTable`-ийн `createLinkForSyncWithLocation` (апп ашигладаггүй).
 */
export const withSafeReturnTo = (base: RouterProvider): RouterProvider => {
  const baseParse = base.parse

  if (!baseParse) return base

  const useSafeParse = (): ParseFunction => {
    const parse = baseParse()

    return useCallback(() => {
      const parsed = parse()

      if (parsed.params?.to === undefined) return parsed

      return { ...parsed, params: { ...parsed.params, to: safeReturnTo(parsed.params.to) } }
    }, [parse])
  }

  return { ...base, parse: useSafeParse }
}
